<div class="w-full">
  <section class="px-3 md:px-6">
    <h1 id="primary-heading">{{ 'error.no_results.subtitle' | translate }}</h1>
    <p class="text-lg">{{ 'error.no_results.searchText' | translate }}</p>
  </section>
</div>
